import { APP_NAME } from "@/lib/brand";

export const tr = {
  brand: {
    name: APP_NAME,
    tagline: "Dijital İnsan Zekası Platformu",
  },
  auth: {
    welcome: `${APP_NAME}'a Hoş Geldiniz`,
    subtitle: "Sağlığınızın dijital ikizi tek bir yerde.",
    email: "E-posta",
    password: "Şifre",
    login: "Giriş Yap",
    register: "Hesap Oluştur",
    name: "Ad Soyad",
    forgotPassword: "Şifremi unuttum",
    needAccount: "Hesabınız yok mu?",
    haveAccount: "Zaten hesabınız var mı?",
    role: "Rol",
    roleMember: "Üye",
    roleClinician: "Klinisyen",
    roleAdmin: "Yönetici",
    language: "Dil",
    submitting: "Gönderiliyor…",
    demoCredentials: "Demo Hesaplar",
    demoMember: "Üye: ayse.demir@mios.health / Member!2026",
    demoClinician: "Klinisyen: dr.kara@mios.health / Clinician!2026",
    demoAdmin: "Yönetici: admin@mios.health / MiOSAdmin!2026",
  },
  nav: {
    overview: "Dijital İkiz",
    medical: "ZekaAI · Tıbbi",
    lifestyle: "OnlyYou · Yaşam",
    assistant: "Mi Brain · Asistan",
    devices: "Cihazlar",
    plugins: "Plugin Kataloğu",
    conscious: "Bilinçli Etkileşim",
    life: "ME Yolculuğu",
    persons: "Tanıdıklar",
    cognitive: "Bilişsel Profil",
    intent: "Niyet Motoru",
    production: "Üretim",
    knowledge: "Bilgi Dokusu",
    patients: "Hastalar",
    users: "Kullanıcılar",
    brainStatus: "Mi Brain Durumu",
    logout: "Çıkış",
  },
  layer: {
    mi: "Mi",
    miSub: "Kullanıcı Deneyimi",
    zekaai: "ZekaAI",
    zekaaiSub: "Tıbbi Zeka",
    onlyyou: "OnlyYou",
    onlyyouSub: "Yaşam Zekası",
    brain: "Mi Brain",
    brainSub: "Merkezi Orkestratör",
  },
  twin: {
    headline: "Dijital İkiz",
    sub: "Sağlık, yaşam ve cihaz verilerinizin canlı özeti.",
    stability: "Stabilite Skoru",
    band: { optimal: "Optimal", monitor: "Takipte", attention: "Dikkat" },
    reasons: "Etkileyen faktörler",
    vitals: "Vital Bulgular",
    labs: "Laboratuvar",
    abnormal: "Anormal",
    medications: "İlaçlar",
    allergies: "Alerjiler",
    conditions: "Tanılı Durumlar",
    lifestyle: "Yaşam",
    sleep: "Uyku",
    steps: "Adım",
    mood: "Ruh hali",
    nutrition: "Beslenme",
    none: "Kayıt yok",
    last: "son",
    explain: "Mi Brain'den Açıklanabilir Öngörü",
    explainCta: "AI Öngörüsü Oluştur",
    explainRunning: "Mi Brain analiz ediyor…",
  },
  medical: {
    title: "ZekaAI · Tıbbi Zeka",
    sub: "Laboratuvar, vital, ilaç, alerji ve tanı kayıtlarınız.",
    addVital: "Vital ekle",
    addLab: "Lab ekle",
    addMed: "İlaç ekle",
  },
  lifestyle: {
    title: "OnlyYou · Yaşam Zekası",
    sub: "Uyku, hareket, beslenme ve ruh hali verileriniz.",
  },
  brain: {
    title: "Mi Brain · Asistan",
    sub: "Açıklanabilir, çok dilli AI sohbet — sağlayıcılar arasında otomatik yönlendirilir.",
    placeholder: `${APP_NAME} Asistanı'na bir şey sorun…`,
    send: "Gönder",
    thinking: "Mi Brain düşünüyor…",
    safetyNote:
      `${APP_NAME} klinik karar destek sistemidir. Tıbbi teşhis veya tedavi yerine geçmez.`,
    newSession: "Yeni oturum",
    taskMedical: "Tıbbi",
    taskLifestyle: "Yaşam",
    taskGeneral: "Genel",
    provider: "Sağlayıcı",
    model: "Model",
  },
  clinician: {
    title: "Hasta Listesi",
    sub: "Atanmış üyelerinizi görüntüleyin ve dijital ikizlerini inceleyin.",
    open: "Aç",
  },
  admin: {
    title: "Yönetici Paneli",
    sub: `${APP_NAME} kullanıcıları ve Mi Brain orkestrasyon durumu.`,
    users: "Kullanıcılar",
    brainStatus: "Mi Brain Durumu",
    routing: "AI Yönlendirme Tablosu",
    providers: "Sağlayıcılar",
    available: "Hazır",
    unavailable: "Yapılandırılmamış",
    layers: "Katmanlar",
    policies: "Politikalar",
  },
  common: {
    loading: "Yükleniyor…",
    error: "Hata",
    retry: "Tekrar dene",
    close: "Kapat",
    save: "Kaydet",
    cancel: "İptal",
    confidence: "Güven",
    member: "Üye",
    clinician: "Klinisyen",
    administrator: "Yönetici",
  },
  meai: {
    title: "ME AI · Dijital Varlık",
    sub: "ME AI bir cihazda değil; cihazlar yalnızca ME AI'a açılan pencerelerdir.",
    presence: "Konum",
    online: "Çevrimiçi",
    offline: "Çevrimdışı",
    activeOn: "Şu an aktif",
    transferTo: "Cihaza taşı",
    claim: "Bu cihazda aç",
    release: "Bağlantıyı bırak",
    protocols: "Bağlantı Protokolleri",
    available: "Hazır",
    needsBridge: "Yerel köprü gerekli",
    needsConfig: "Yapılandırılmamış",
    devices: "Cihazlar",
    addDevice: "Yeni cihaz",
    deviceName: "Cihaz adı",
    deviceKind: "Tür",
    kinds: {
      phone: "Telefon",
      tablet: "Tablet",
      desktop: "Masaüstü",
      smart_tv: "Akıllı TV",
      smart_speaker: "Akıllı Hoparlör",
      wearable: "Giyilebilir",
      medical_capsule: "Tıbbi Kapsül",
      robot: "Robot",
      iot: "IoT",
      imaging: "Görüntüleme",
      lab_instrument: "Lab Cihazı",
      ehr_endpoint: "EHR Uçnoktası",
      unknown: "Bilinmeyen",
    },
    discover: "Yakındaki cihazları tara",
    handoverHint:
      "Telefondan başlat, kapsüle adım at, akıllı TV'de devam et — sohbet hiç durmaz.",
  },
  living: {
    openDashboard: "Çalışma alanı",
    here: "Buradayım",
    listening: "dinliyorum",
    thinking: "düşünüyorum",
    speaking: "konuşuyorum",
    iAmHere: "buradayım",
    speakOrType: "Konuş ya da yaz — ben buradayım.",
    typeOnly: "Yaz, ben buradayım.",
  },
  person: {
    eyebrow: "Universal Person Engine",
    title: "ME'nin tanıdıkları",
    sub: "ME karşılaştığı her kişiyi kalıcı olarak hatırlar. Her profil ayrı, izinli ve düzenlenebilir.",
    known: "Tanınan kişiler",
    search: "Ad ile ara…",
    empty: "Henüz kimseyle tanışılmadı.",
    profile: "Profil",
    metSince: "İlk tanışma",
    displayName: "Görünen ad",
    tags: "Etiketler (virgülle)",
    notes: "Notlar",
    consent: "İzinler",
    encounters: "Karşılaşma",
    recentEncounters: "Son karşılaşmalar",
    noEncounters: "Henüz karşılaşma kaydı yok.",
    relationships: {
      owner: "Sahip",
      family: "Aile",
      friend: "Arkadaş",
      visitor: "Ziyaretçi",
      patient: "Hasta",
      clinician: "Klinisyen",
      peer: "Akran",
      guest: "Konuk",
    },
    consentKeys: {
      remember_name: "Adı hatırla",
      remember_face: "Yüzü hatırla",
      remember_voice: "Sesi hatırla",
      remember_devices: "Cihazları hatırla",
      remember_conversations: "Konuşmaları hatırla",
      remember_preferences: "Tercihleri hatırla",
      access_medical_history: "Tıbbi geçmişe erişim",
    },
  },
  cognitive: {
    eyebrow: "Cognitive Profile Engine",
    title: "Bilişsel Profil",
    sub: "ME üslubunu öğrenir — tıbbi içeriği asla değiştirmez.",
    noticeTitle: "Tıbbi olgular kalıcıdır",
    notice: "Bu profil yalnızca iletişim, rapor ve sunum üslubunu yönlendirir. Kanıta dayalı tıbbi bilgiler asla bu profilden etkilenmez.",
    dimensions: "Boyutlar",
    fields: {
      communication_style: "İletişim üslubu",
      report_style: "Rapor formatı",
      explanation_depth: "Açıklama derinliği",
      scientific_level: "Bilimsel seviye",
      document_format: "Tercih edilen belge",
      visualisations: "Görselleştirme",
      workflow: "İş akışı",
    },
    values: {
      direct: "Direkt",
      warm: "Sıcak",
      concise: "Özlü",
      narrative: "Anlatımcı",
      clinical: "Klinik",
      executive: "Yönetici",
      bullet: "Madde imli",
      brief: "Kısa",
      balanced: "Dengeli",
      deep: "Derin",
      patient: "Hasta",
      clinician: "Klinisyen",
      researcher: "Araştırmacı",
      markdown: "Markdown",
      pdf: "PDF",
      word: "Word",
      pptx: "PowerPoint",
      html: "HTML",
      tables: "Tablolar",
      charts: "Grafikler",
      timeline: "Zaman çizelgesi",
      minimal: "Sade",
      morning_first: "Sabah öncelikli",
      inbox_zero: "Gelen kutusu sıfır",
      deep_work: "Derin çalışma",
      batched: "Toplu",
    },
    confidence: "Güven",
    samples: "Örnek sayısı",
    updatedAt: "Son güncelleme",
    save: "Kaydet",
    savedHint: "Kaydedildi",
  },
  intent: {
    eyebrow: "Intent Prediction Engine",
    title: "Niyet Tahmin Motoru",
    sub: "ME, sen daha cümleyi bitirmeden veriyi önden hazırlar. Hiçbir karar otomatik alınmaz — yalnızca bekleme süresi azaltılır.",
    tryIt: "Niyet tahminini dene",
    partialPlaceholder: "Örn: Hasta için tam bir rapor hazırla…",
    predict: "Tahmin et",
    predicting: "Hesaplanıyor…",
    hypotheses: "Tahminler",
    noHypotheses: "Kural tabanlı eşleşme bulunamadı.",
    warmCache: "Sıcak önbellek",
    warmEmpty: "Henüz ön-yüklenmiş veri yok.",
  },
  production: {
    eyebrow: "Medical Production Engine",
    title: "Tıbbi Üretim Motoru",
    sub: "ME profesyonel raporlar, sunumlar ve dokümanlar üretir — üslup bilişsel profile uyarlanır; tıbbi olgular kanıta dayalı kalır.",
    generator: "Üretici",
    kind: "Belge türü",
    member: "Üye",
    titleField: "Başlık",
    titlePlaceholder: "Otomatik üretilsin",
    focus: "Odak (opsiyonel)",
    focusPlaceholder: "Örn: uyku, hipotiroidi takibi…",
    generate: "Üret",
    generating: "ME üretiyor…",
    busyHint: "ME, profili ve verileri okuyup belgenizi yazıyor. 10-60 saniye sürebilir; sayfayı kapatmayın.",
    activeDocument: "Aktif belge",
    empty: "Henüz bir belge üretilmedi. Sol panelden başla.",
    history: "Belge geçmişi",
    noHistory: "Henüz belge yok.",
    evidenceTitle: "Kanıt Müfettişi",
    evidenceHint: "Her kanıt çipine tıklayarak kaynağın seviyesini ve güvenirliğini incele.",
    evidenceNote: "ME her belgenin altında kullandığı kanıtları şeffafça gösterir. Hiçbir tıbbi olgu kanıt seviyesinin üzerine yazılmaz.",
    evidenceMeta: {
      region: "Bölge",
      domain: "Alan",
      source_type: "Kaynak türü",
      reliability: "Güvenirlik",
      version: "Sürüm",
      layer: "Katman",
    },
  },
  meet: {
    title: "ME ile tanış",
    sub: "ME bir uygulama değil, kalıcı bir Dijital Varlıktır.",
    greeting: "Merhaba, ben ME. Sizinle tanışmaktan memnuniyet duydum. Devam etmek ister misiniz?",
    greeting2: "ME selamlıyor…",
    continue: "Devam et",
    askName: "Adın nedir?",
    namePlaceholder: "Adın…",
    consentLine: "Adımı hatırlamana izin veriyorum.",
    submit: "Tanıştık de",
    skipName: "Şimdilik atla",
    meSays: "ME diyor ki",
    personCreated: "Oluşturulan ME Person ID",
    restart: "Yeniden başla",
  },
  knowledge: {
    eyebrow: "ME Knowledge Fabric",
    title: "Bilgi Dokusu",
    sub: "ME asla tüm bilgileri eşit kabul etmez. Her bilgi kaynağı kanıt seviyesi taşır; kanıta dayalı, tarihsel, geleneksel, keşifsel ve deneysel bilgi net olarak ayrılır.",
    layers: {
      bootstrap: "Bootstrap",
      demo: "Demo",
      user: "Kullanıcı",
      external: "Dış kaynak",
    },
    tabs: {
      library: "Kütüphane",
      ontology: "Ontolojiler",
      evidence: "Kanıt seviyeleri",
      import_: "İçe aktar",
    },
    tiers: {
      evidence_based: "Kanıta dayalı tıp",
      historical: "Tarihsel tıbbi bilgi",
      traditional: "Geleneksel tıp",
      emerging: "Keşifsel araştırma",
      experimental: "Deneysel teknoloji",
      user_owned: "Kullanıcı kaynakları",
    },
    evidenceShort: {
      level_a: "Düzey A",
      level_b: "Düzey B",
      level_c: "Düzey C",
      expert_consensus: "Uzlaşı",
      historical: "Tarihsel",
      traditional: "Geleneksel",
      exploratory: "Keşifsel",
      experimental: "Deneysel",
      user_supplied: "Kullanıcı",
    },
    searchPlaceholder: "Bilgi tabanında ara…",
    allDomains: "Tüm alanlar",
    refresh: "Yenile",
    emptyBucket: "Bu kategoride henüz kayıt yok.",
    addItem: "Yeni bilgi ekle",
    myItems: "Benim kaynaklarım",
    noUserItems: "Henüz kaynak eklenmedi.",
    submit: "Kaydet",
    copyrightWarning: "Telifli içerik eklemeyin. Yalnızca paylaşma hakkına sahip olduğunuz materyalleri ekleyin.",
    fields: {
      title: "Başlık",
      abstract: "Özet",
      evidence_level: "Kanıt seviyesi",
      domain: "Alan",
      region: "Bölge",
      source_type: "Kaynak türü",
      publication_date: "Yayın tarihi",
      source_url: "Bağlantı (opsiyonel)",
    },
  },
};

export const en = {
  brand: {
    name: APP_NAME,
    tagline: "Digital Human Intelligence Platform",
  },
  auth: {
    welcome: `Welcome to ${APP_NAME}`,
    subtitle: "The digital twin of your health, in one place.",
    email: "Email",
    password: "Password",
    login: "Sign in",
    register: "Create account",
    name: "Full name",
    forgotPassword: "Forgot password",
    needAccount: "Don't have an account?",
    haveAccount: "Already have an account?",
    role: "Role",
    roleMember: "Member",
    roleClinician: "Clinician",
    roleAdmin: "Administrator",
    language: "Language",
    submitting: "Submitting…",
    demoCredentials: "Demo accounts",
    demoMember: "Member: ayse.demir@mios.health / Member!2026",
    demoClinician: "Clinician: dr.kara@mios.health / Clinician!2026",
    demoAdmin: "Administrator: admin@mios.health / MiOSAdmin!2026",
  },
  nav: {
    overview: "Digital Twin",
    medical: "ZekaAI · Medical",
    lifestyle: "OnlyYou · Lifestyle",
    assistant: "Mi Brain · Assistant",
    devices: "Devices",
    plugins: "Plugin Catalog",
    conscious: "Conscious Interaction",
    life: "ME Journey",
    persons: "People ME knows",
    cognitive: "Cognitive Profile",
    intent: "Intent Engine",
    production: "Production",
    knowledge: "Knowledge Fabric",
    patients: "Patients",
    users: "Users",
    brainStatus: "Mi Brain Status",
    logout: "Sign out",
  },
  layer: {
    mi: "Mi",
    miSub: "User Experience",
    zekaai: "ZekaAI",
    zekaaiSub: "Medical Intelligence",
    onlyyou: "OnlyYou",
    onlyyouSub: "Lifestyle Intelligence",
    brain: "Mi Brain",
    brainSub: "Central Orchestrator",
  },
  twin: {
    headline: "Digital Twin",
    sub: "Live summary of your health, lifestyle and device data.",
    stability: "Stability Score",
    band: { optimal: "Optimal", monitor: "Monitor", attention: "Attention" },
    reasons: "Contributing factors",
    vitals: "Vitals",
    labs: "Laboratory",
    abnormal: "Abnormal",
    medications: "Medications",
    allergies: "Allergies",
    conditions: "Conditions",
    lifestyle: "Lifestyle",
    sleep: "Sleep",
    steps: "Steps",
    mood: "Mood",
    nutrition: "Nutrition",
    none: "No records",
    last: "last",
    explain: "Explainable insight from Mi Brain",
    explainCta: "Generate AI insight",
    explainRunning: "Mi Brain is analysing…",
  },
  medical: {
    title: "ZekaAI · Medical Intelligence",
    sub: "Your labs, vitals, medications, allergies and conditions.",
    addVital: "Add vital",
    addLab: "Add lab",
    addMed: "Add medication",
  },
  lifestyle: {
    title: "OnlyYou · Lifestyle Intelligence",
    sub: "Your sleep, movement, nutrition and mood.",
  },
  brain: {
    title: "Mi Brain · Assistant",
    sub: "Explainable, multilingual AI chat — auto-routed across providers.",
    placeholder: `Ask ${APP_NAME} Assistant…`,
    send: "Send",
    thinking: "Mi Brain is thinking…",
    safetyNote:
      `${APP_NAME} is a clinical decision support system. It does not replace diagnosis or treatment.`,
    newSession: "New session",
    taskMedical: "Medical",
    taskLifestyle: "Lifestyle",
    taskGeneral: "General",
    provider: "Provider",
    model: "Model",
  },
  clinician: {
    title: "Patient roster",
    sub: "Browse your assigned members and review their digital twins.",
    open: "Open",
  },
  admin: {
    title: "Administrator console",
    sub: `${APP_NAME} users and Mi Brain orchestration status.`,
    users: "Users",
    brainStatus: "Mi Brain status",
    routing: "AI routing table",
    providers: "Providers",
    available: "Available",
    unavailable: "Not configured",
    layers: "Layers",
    policies: "Policies",
  },
  common: {
    loading: "Loading…",
    error: "Error",
    retry: "Retry",
    close: "Close",
    save: "Save",
    cancel: "Cancel",
    confidence: "Confidence",
    member: "Member",
    clinician: "Clinician",
    administrator: "Administrator",
  },
  meai: {
    title: "ME AI · Digital Being",
    sub: "ME AI does not live inside a device. Devices are only windows into ME AI.",
    presence: "Presence",
    online: "Online",
    offline: "Offline",
    activeOn: "Active on",
    transferTo: "Transfer to device",
    claim: "Open here",
    release: "Release",
    protocols: "Connectivity protocols",
    available: "Available",
    needsBridge: "Needs native bridge",
    needsConfig: "Not configured",
    devices: "Devices",
    addDevice: "Add device",
    deviceName: "Device name",
    deviceKind: "Kind",
    kinds: {
      phone: "Phone",
      tablet: "Tablet",
      desktop: "Desktop",
      smart_tv: "Smart TV",
      smart_speaker: "Smart speaker",
      wearable: "Wearable",
      medical_capsule: "Medical capsule",
      robot: "Robot",
      iot: "IoT",
      imaging: "Imaging",
      lab_instrument: "Lab instrument",
      ehr_endpoint: "EHR endpoint",
      unknown: "Unknown",
    },
    discover: "Scan nearby",
    handoverHint:
      "Start on your phone, step into the capsule, continue on the smart TV — the conversation never restarts.",
  },
  living: {
    openDashboard: "Workspace",
    here: "I am here",
    listening: "listening",
    thinking: "thinking",
    speaking: "speaking",
    iAmHere: "i am here",
    speakOrType: "Speak or type — I am here.",
    typeOnly: "Type, I am here.",
  },
  person: {
    eyebrow: "Universal Person Engine",
    title: "People ME knows",
    sub: "ME persistently remembers every person it meets. Each profile is private, consented and editable.",
    known: "Known people",
    search: "Search by name…",
    empty: "Nobody met yet.",
    profile: "Profile",
    metSince: "First met",
    displayName: "Display name",
    tags: "Tags (comma-separated)",
    notes: "Notes",
    consent: "Consent",
    encounters: "Encounters",
    recentEncounters: "Recent encounters",
    noEncounters: "No encounters recorded yet.",
    relationships: {
      owner: "Owner",
      family: "Family",
      friend: "Friend",
      visitor: "Visitor",
      patient: "Patient",
      clinician: "Clinician",
      peer: "Peer",
      guest: "Guest",
    },
    consentKeys: {
      remember_name: "Remember name",
      remember_face: "Remember face",
      remember_voice: "Remember voice",
      remember_devices: "Remember devices",
      remember_conversations: "Remember conversations",
      remember_preferences: "Remember preferences",
      access_medical_history: "Access medical history",
    },
  },
  cognitive: {
    eyebrow: "Cognitive Profile Engine",
    title: "Cognitive Profile",
    sub: "ME learns your voice — it never alters medical content.",
    noticeTitle: "Medical facts are immutable",
    notice: "This profile only guides communication, reporting and presentation style. Evidence-based medical information is never modified by this profile.",
    dimensions: "Dimensions",
    fields: {
      communication_style: "Communication style",
      report_style: "Report style",
      explanation_depth: "Explanation depth",
      scientific_level: "Scientific level",
      document_format: "Preferred document",
      visualisations: "Visualisations",
      workflow: "Workflow",
    },
    values: {
      direct: "Direct",
      warm: "Warm",
      concise: "Concise",
      narrative: "Narrative",
      clinical: "Clinical",
      executive: "Executive",
      bullet: "Bulleted",
      brief: "Brief",
      balanced: "Balanced",
      deep: "Deep",
      patient: "Patient",
      clinician: "Clinician",
      researcher: "Researcher",
      markdown: "Markdown",
      pdf: "PDF",
      word: "Word",
      pptx: "PowerPoint",
      html: "HTML",
      tables: "Tables",
      charts: "Charts",
      timeline: "Timeline",
      minimal: "Minimal",
      morning_first: "Morning first",
      inbox_zero: "Inbox zero",
      deep_work: "Deep work",
      batched: "Batched",
    },
    confidence: "Confidence",
    samples: "Samples",
    updatedAt: "Updated",
    save: "Save",
    savedHint: "Saved",
  },
  intent: {
    eyebrow: "Intent Prediction Engine",
    title: "Intent Prediction",
    sub: "ME prefetches likely data while you're still talking. Nothing is decided autonomously — only waiting time is reduced.",
    tryIt: "Try a prediction",
    partialPlaceholder: "e.g. Generate a full patient report…",
    predict: "Predict",
    predicting: "Computing…",
    hypotheses: "Hypotheses",
    noHypotheses: "No rule-based match.",
    warmCache: "Warm cache",
    warmEmpty: "No prefetched data yet.",
  },
  production: {
    eyebrow: "Medical Production Engine",
    title: "Medical Production",
    sub: "ME generates professional reports, presentations and documents — the voice adapts to your cognitive profile; medical facts remain evidence-based.",
    generator: "Generator",
    kind: "Document kind",
    member: "Member",
    titleField: "Title",
    titlePlaceholder: "Auto-generated",
    focus: "Focus (optional)",
    focusPlaceholder: "e.g. sleep, hypothyroid follow-up…",
    generate: "Generate",
    generating: "ME is producing…",
    busyHint: "ME is reading your profile and your data, then drafting your document. It may take 10-60 seconds — please don't close the tab.",
    activeDocument: "Active document",
    empty: "No document yet. Start from the left panel.",
    history: "Document history",
    noHistory: "No documents yet.",
    evidenceTitle: "Evidence Inspector",
    evidenceHint: "Click any evidence chip to inspect its level and reliability.",
    evidenceNote: "ME transparently shows every source beneath every document. No medical fact is ever overwritten by personalisation.",
    evidenceMeta: {
      region: "Region",
      domain: "Domain",
      source_type: "Source type",
      reliability: "Reliability",
      version: "Version",
      layer: "Layer",
    },
  },
  meet: {
    title: "Meet ME",
    sub: "ME is not an application; it is a persistent Digital Being.",
    greeting: "Hello, I am ME. It is a pleasure to meet you. Shall we continue?",
    greeting2: "ME is greeting…",
    continue: "Continue",
    askName: "What is your name?",
    namePlaceholder: "Your name…",
    consentLine: "I consent to ME remembering my name.",
    submit: "We've met",
    skipName: "Skip for now",
    meSays: "ME says",
    personCreated: "Created ME Person ID",
    restart: "Start over",
  },
  knowledge: {
    eyebrow: "ME Knowledge Fabric",
    title: "Knowledge Fabric",
    sub: "ME never treats all information equally. Every source carries an evidence level — evidence-based, historical, traditional, exploratory and experimental knowledge are clearly separated.",
    layers: {
      bootstrap: "Bootstrap",
      demo: "Demo",
      user: "User",
      external: "External",
    },
    tabs: {
      library: "Library",
      ontology: "Ontologies",
      evidence: "Evidence levels",
      import_: "Import",
    },
    tiers: {
      evidence_based: "Evidence-based medicine",
      historical: "Historical medical knowledge",
      traditional: "Traditional medicine",
      emerging: "Exploratory research",
      experimental: "Experimental technology",
      user_owned: "User-supplied",
    },
    evidenceShort: {
      level_a: "Level A",
      level_b: "Level B",
      level_c: "Level C",
      expert_consensus: "Consensus",
      historical: "Historical",
      traditional: "Traditional",
      exploratory: "Exploratory",
      experimental: "Experimental",
      user_supplied: "User",
    },
    searchPlaceholder: "Search the knowledge base…",
    allDomains: "All domains",
    refresh: "Refresh",
    emptyBucket: "Nothing in this bucket yet.",
    addItem: "Add knowledge",
    myItems: "My sources",
    noUserItems: "No sources added yet.",
    submit: "Save",
    copyrightWarning: "Do not add copyrighted content. Only materials you are entitled to share.",
    fields: {
      title: "Title",
      abstract: "Abstract",
      evidence_level: "Evidence level",
      domain: "Domain",
      region: "Region",
      source_type: "Source type",
      publication_date: "Publication date",
      source_url: "Link (optional)",
    },
  },
};

export const dictionaries = { tr, en };

// MVP exposes TR + EN. Architecture is ready for ja/de/fr/es/ar/ru/zh —
// add the dictionaries and they will appear in the language switcher.
export const SUPPORTED_LANGUAGES = [
  { code: "tr", label: "Türkçe" },
  { code: "en", label: "English" },
];
